export default __webpack_public_path__ + "static/media/certificate.f22d6be7.svg";